import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { ReactComponent as MailIcon } from "assets/images/iconsV2/mail-01.svg";

interface TopNavCreatedByProps {
  name: string;
  email?: string;
  subtitle?: string;
  link?: {
    to: string;
    label: string;
    icon?: React.ReactNode;
  };
  automationIdPrefix?: string;
}

// This component is used by both Quote Request Details and Quick Request Details in the TopNav.
function TopNavCreatedBy({ name, email, subtitle, link, automationIdPrefix }: TopNavCreatedByProps) {
  const intl = useIntl();
  const idPrefix = automationIdPrefix || "topnav-v2-created-by";

  return (
    <div className="topnav-v2__detail-col topnav-v2__creator-col" data-testid={`${idPrefix}-container`}>
      <span className="topnav-v2__detail-label" data-testid={`${idPrefix}-label`}>
        <FormattedMessage id="general.createdBy" defaultMessage="Created by" />
      </span>
      <div className="topnav-v2__creator-row" data-testid={`${idPrefix}-row`}>
        <div>
          <span className="topnav-v2__creator-name" data-testid={`${idPrefix}-name`}>
            {name}
          </span>
          {subtitle && (
            <span className="topnav-v2__creator-team" data-testid={`${idPrefix}-subtitle`}>
              {subtitle}
            </span>
          )}
        </div>
        {email && (
          <button
            type="button"
            className="topnav-v2__mail-btn"
            onClick={() => window.open(`mailto:${email}`)}
            aria-label={intl.formatMessage({ id: "general.sendEmail", defaultMessage: "Send email" })}
            data-testid={`${idPrefix}-email-button`}
          >
            <MailIcon data-testid={`${idPrefix}-email-icon`} />
          </button>
        )}
      </div>
      {link && (
        <Link to={link.to} className="topnav-v2__qr-link" data-testid={`${idPrefix}-link`}>
          {link.icon && link.icon}
          <span data-testid={`${idPrefix}-link-label`}>{link.label}</span>
        </Link>
      )}
    </div>
  );
}

export default TopNavCreatedBy;

TopNavCreatedBy.defaultProps = {
  email: undefined,
  subtitle: undefined,
  link: undefined,
  automationIdPrefix: undefined,
};
